import React from 'react';
import Favicon from '../core/common/Favicon';
import { connect } from 'react-redux';
import { getBrandCommon } from '../../api/redux-watson/watson-config-selectors';

function BrandedFavicon({ icon }) {
  if (icon) {
    return <Favicon icon={icon} />;
  }
  return null;
}

const mapStateToProps = state => ({
  icon: getBrandCommon(state).favicon,
});

export default connect(mapStateToProps)(BrandedFavicon);
